import { getTemplateNavHeaderStyles } from './NavHeaderContextual.styles'
import {
  tryLoadDependencies,
  WebAwesomeComponent,
} from '@/components/webcomponents/Global/loadDependency'

const t = document.createElement('template')
t.innerHTML = `
<wa-details exportparts="base,header,summary,content,icon" role="group">
  <slot></slot>
</wa-details>
`

class NavHeaderContextualMenuItem extends HTMLElement {
  private waDetails: HTMLElement | null = null

  constructor() {
    super()

    tryLoadDependencies(document, [WebAwesomeComponent.Details])

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  connectedCallback() {
    this.waDetails = this.shadowRoot?.querySelector('wa-details') ?? null

    const summary = this.getAttribute('summary')
    if (summary && this.waDetails) {
      this.waDetails.setAttribute('summary', summary)
    }

    this.addEventListener('click', this.handleClick.bind(this))
    this.addEventListener('keydown', this.handleKeyEvent.bind(this))

    this.updateSelectedState()
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick.bind(this))
    this.removeEventListener('keydown', this.handleKeyEvent.bind(this))
  }

  private handleClick(event: Event) {
    event.stopPropagation()

    const allMenuItems = document.querySelectorAll('ts-navheader-contextual-menu-item[selected]')
    allMenuItems.forEach((item) => {
      if (item !== this) {
        item.removeAttribute('selected')
      }
    })

    this.setAttribute('selected', '')
  }

  private handleKeyEvent(event: KeyboardEvent) {
    // Only handle Space and Enter for selection, allow other keys to bubble for navigation
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault()
      event.stopPropagation()

      const allMenuItems = document.querySelectorAll('ts-navheader-contextual-menu-item[selected]')
      allMenuItems.forEach((item) => {
        if (item !== this) {
          item.removeAttribute('selected')
        }
      })

      this.setAttribute('selected', '')
    }
    // Allow Arrow keys, Tab, and Escape to bubble up for menu navigation
  }

  private updateSelectedState() {
    if (this.waDetails) {
      if (this.hasAttribute('selected')) {
        this.waDetails.classList.add('selected')
      } else {
        this.waDetails.classList.remove('selected')
      }
    }
  }

  static get observedAttributes() {
    return ['summary', 'selected']
  }
  attributeChangedCallback(name: string, _oldValue: string, newValue: string) {
    if (name === 'summary' && this.waDetails) {
      this.waDetails.setAttribute('summary', newValue)
    }
    if (name === 'selected') {
      this.updateSelectedState()
    }
  }
}

if (!customElements.get('ts-navheader-contextual-menu-item')) {
  customElements.define('ts-navheader-contextual-menu-item', NavHeaderContextualMenuItem)
}
export { NavHeaderContextualMenuItem }
